module.exports = __webpack_public_path__ + "static/media/dashboardSelected.eda26ad4.svg";